export const createSelectedRoomState = () => ({
  chatType: '',
  roomType: '',
  roomNo: null,
  orderNo: null,
  store: {},
  profiles: [],
  order: {}
});

export const createChatModuleState = () => ({
  activeCount: 0, // 채팅 뉴마크 관련
  meta: {
    name: ''
  },
  header: {
    userNo: 0,
    accessToken: ''
  },
  desiredRoomNo: null,
  subscribedRoomNo: null,
  selectedRoom: createSelectedRoomState(),
  room: {
    page: 1,
    limit: 10,
    totalPage: 2,
    nextId: null,
    roomType: null,
    orderTab: null,
    chatTab: 'order',
    data: []
  },
  chats: {
    page: 1,
    limit: 10,
    totalPage: 2,
    data: []
  },
  imageUploadState: false,
  shouldIMoveScroll: false,
  bubbleCounts: {
    incomingOrderBubbleCount: 0,
    progressedOrderBubbleCount: 0,
    reserveOrderBubbleCount: 0,
    orderBubbleCount: 0,
    inquiryBubbleCount: 0,
    totalBubbleCount: 0
  }
});
